<div class="SLV2-playlist-card-box" [ngClass]="{'completed': playlistCardData.completed, 'resume': playlistCardData.resume}">
    <div class="SLV2-playlist-left-col" (click)="emitVideoSelectEvent()">
        <div class="SLV2-topic-icon-wrap">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/video-icon.svg" />
            <img src="selflearnv2-ui/assets/img/self-learn-v2/green-tick.svg" class="complete" />
        </div>
        <div class="SLV2-pltlst-info">
            <h4 class="SLV2-pltlst-info-heading">{{playlistCardData.title}}</h4>
            <h5 class="SLV2-pltlst-info-subheading">{{getVideoDisplayTime(playlistCardData.duration)}}</h5>
        </div>
    </div>
    <div class="SLV2-playlist-right-col">
        <button class="SLV2-topic-bookmark-btn show-on-hover" [ngClass]="{'marked': playlistCardData.isBookmarked}" (click)="bookMarkCurrentVideo()">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/bookmark-icon.svg" />
        </button>
    </div>
</div>
